<template>
  <CardExpand
    title="Dados Básicos"
    :expandido="true"
    class="my-4 custom-card"
    somente-icone
  >
    <v-row dense class="ma-0 mt-2 mb-2">
      <v-col cols="12" md="4" class="pa-0 pr-4">
        <sds-input-control label="Número do Parecer*:">
          <div class="d-flex align-end">
            <SdsTextField
              id="nuParecer"
              aria-label="Número do Parecer*:"
              v-model="parecerReferencial.nuParecer"
              :placeholder="'0'.repeat(9)"
              v-mask="'#########'"
              data-testid="field-nuParecer"
            />
            <span class="mr-3 ml-3 mb-2">/</span>
            <sds-input-control for="nuAnoParecer" field-name="nuAnoParecer">
              <SdsTextField
                id="nuAnoParecer"
                aria-label="Ano do Parecer"
                class="year-field"
                v-mask="'####'"
                v-model="parecerReferencial.nuAnoParecer"
                :placeholder="'a'.repeat(4)"
                data-testid="field-nuAnoParecer"
              />
            </sds-input-control>
          </div>
        </sds-input-control>
      </v-col>
      <v-col cols="12" md="6" class="pa-0 pr-4">
        <div class="d-flex">
          <SdsDateField
            id="dtParecer"
            class="min-w-date-field"
            v-model="parecerReferencial.dtParecer"
            :max="moment().format('DD/MM/YYYY')"
            label="Aprovação da Presidência*:"
            :disabled="isEditing"
            data-testid="date-dtParecer"
            label-greater-than-maximum="A aprovação da Presidência não pode ser maior do que a data atual."
          />

          <SdsDateField
            id="dtValidade"
            class="ml-4 min-w-date-field"
            v-model="parecerReferencial.dtValidade"
            label="Data de Validade*:"
            :min="
              moment(parecerReferencial.dtParecer, 'DD/MM/YYYY')
                .add(1, 'day')
                .format('DD/MM/YYYY')
            "
            :max="maxDtValidade"
            label-less-than-minimum="Data de validade não pode ser igual ou inferior à aprovação da Presidência"
            label-greater-than-maximum="Data de validade do parecer não poderá ser superior a 2 anos"
            :disabled="isEditing"
            data-testid="date-dtValidade"
          />
        </div>
      </v-col>
    </v-row>
    <v-row dense class="ma-0 mt-2 mb-2">
      <v-col cols="12" md="4" class="pa-0 pr-4">
        <sds-input-control label="Número do Processo*:">
          <div class="d-flex align-end">
            <SdsTextField
              id="nuAnoProcessoOficial"
              class="d-inline-block year-field"
              aria-label="Ano do Processo"
              v-mask="'####'"
              v-model="parecerReferencial.nuAnoProcessoOficial"
              :placeholder="'a'.repeat(4)"
              :disabled="
                isIntegracaoCPA ||
                (isEditing &&
                  parecerReferencial.flCadastroCpa === SimNao.FL_SIM)
              "
              :filled="
                isIntegracaoCPA ||
                (isEditing &&
                  parecerReferencial.flCadastroCpa === SimNao.FL_SIM)
              "
              data-testid="field-nuAnoProcessoOficial"
            />
            <span class="mr-3 ml-3 mb-2 d-inline-block">/</span>
            <SdsTextField
              id="nuProcessoOficial"
              class="d-inline-block"
              aria-label="Número do Processo"
              v-mask="'##########'"
              v-model="parecerReferencial.nuProcessoOficial"
              :placeholder="'0'.repeat(10)"
              :disabled="
                isIntegracaoCPA ||
                (isEditing &&
                  parecerReferencial.flCadastroCpa === SimNao.FL_SIM)
              "
              :filled="
                isIntegracaoCPA ||
                (isEditing &&
                  parecerReferencial.flCadastroCpa === SimNao.FL_SIM)
              "
              data-testid="field-nuProcessoOficial"
            />
          </div>
        </sds-input-control>
      </v-col>
    </v-row>
    <v-row dense class="ma-0 mt-2 mb-2">
      <v-col cols="6" class="pa-0 pr-4">
        <div class="d-flex">
          <v-checkbox
            id="flMostraInternet"
            v-model="parecerReferencial.flMostraInternet"
            :true-value="SimNao.FL_SIM"
            :false-value="SimNao.FL_NAO"
            label="Disponível na Web"
            class="pr-5 mt-0"
            :disabled="parecerReferencial.flForaUso === SimNao.FL_SIM"
            data-testid="checkbox-flMostraInternet"
          />

          <v-checkbox
            id="flForaUso"
            v-model="parecerReferencial.flForaUso"
            :true-value="SimNao.FL_SIM"
            :false-value="SimNao.FL_NAO"
            label="Inativo"
            class="pr-5 mt-0"
            v-if="isEditing"
            @change="store.validarForaUso"
            data-testid="checkbox-flForaUso"
          />
        </div>
      </v-col>
    </v-row>
  </CardExpand>
</template>

<script lang="ts" setup>
import CardExpand from '@/views/components/CardExpand.vue';
import SdsDateField from '@/components/SdsDateField.vue';
import moment from 'moment';
import SdsTextField from '@/components/SdsTextField.vue';
import { storeToRefs } from 'pinia';
import { useCadastroParecerReferencialStore } from '../../store/CadastroParecerReferencialStore';
import { watch } from 'vue';
import { SimNao } from '@/types/enum/SimNao';

const store = useCadastroParecerReferencialStore();
const { parecerReferencial, maxDtValidade, isIntegracaoCPA, isEditing } =
  storeToRefs(store);

watch(
  () => parecerReferencial.value.dtParecer,
  async () => {
    await store.calcularDtValidade(false);
  }
);
</script>

<style scoped>
.min-w-date-field {
  min-width: 220px;
}
</style>
